import { VariableType } from '../Variables/VariableDefinition.Interface'

export enum ConversationQueryType {
  RECENT = 'recent',
  NOT_ARCHIVED = 'not-archived',
  ARCHIVED = 'archived'
}

export interface BotInterface {
  id: string
  name: string
  avatar?: string
  variables: VariablesMap
  userDisplayNameVariableId?: string
}

export interface VariableDefinition {
  id: string
  name: string
  type?: VariableType
  hidden?: boolean
  protected?: boolean
  entity?: boolean
  bot?: boolean
}

export interface VariablesMap {
  [key: string]: VariableDefinition
}
